import type { AICopywriterPostChild, Block } from '$lib/types/AICopywriter/types';
import { parseTextBlockFromPostChild } from '$lib/ai/post/utils/parseTextBlockFromPostChild';

export const convertPostChildrenToBlocks = (postChildren: AICopywriterPostChild[]) => {
	return postChildren.reduce<Block[]>((blocks, postChild) => {
		if (postChild.type === 'text') {
			const parsedBlock = parseTextBlockFromPostChild(postChild);

			// A null block means it was not a valid text block and we will not include it (e.g., empty or unsupported tag)
			if (!parsedBlock) {
				return blocks;
			}

			blocks.push(parsedBlock);
			return blocks;
		} else {
			blocks.push({
				id: postChild.id,
				type: 'context',
				content: postChild.type,
			} satisfies Block);
			return blocks;
		}
	}, []);
};
